// extracted by mini-css-extract-plugin
module.exports = {"sideNavbar":"side-nav-menu_sideNavbar__cC7TY","selectedOption":"side-nav-menu_selectedOption__3OfZF","option":"side-nav-menu_option__2ol4m"};